<template>
    
    <div class="tabs">
      <div>
        <h2 class="tab-title">通い放題プラン</h2>
        <div class="plan-explanation">
          <p class="plan-explanation-main">月何回でも定期通い放題！</p>
          <p class="plan-explanation-sub">施術内容：キャビテーション、ラジオ波<br><span class="plan-small">※一部のメニューに光フェイシャル付</span></p>
        </div>
      </div>
      <div class="btn-container">
        <!--<button v-for="(tab, index) in tabs"
                :key="tab.id"
                :class="{ active: currentTab === index }"
                @click="currentTab = index">{{ tab.tabName }}</button>-->
          <div class="button-box button-color-1" v-on:click="currentTab = 0">3ヶ月</div>
          <div class="button-box button-color-2" v-on:click="currentTab = 1">6ヶ月</div>
          <div class="button-box button-color-3" v-on:click="currentTab = 2">12ヶ月</div>
      </div>
      <div class="tab-content">
        <div class="tab1" v-show="currentTab === 0">
          <img class="tab-img" src="./img/open-15_3month01.png" alt="3ヶ月">
        </div>
        <div class="tab2" v-show="currentTab === 1">
          <img class="tab-img" src="./img/open-15_6month01.png" alt="6ヶ月">
        </div>
        <div class="tab3" v-show="currentTab === 2">
          <img class="tab-img" src="./img/open-15_12month01.png" alt="12ヶ月">
        </div>
        <p class="menu_text">※価格はすべて税込表示となっております。</p>
      </div>

      <div class="btn-container">
        <!--<button v-for="(tab, index) in tabs"
                :key="tab.id"
                :class="{ active: currentTab === index }"
                @click="currentTab = index">{{ tab.tabName }}</button>-->
          <div class="button-box button-color-1" v-on:click="currentTab = 0">3ヶ月</div>
          <div class="button-box button-color-2" v-on:click="currentTab = 1">6ヶ月</div>
          <div class="button-box button-color-3" v-on:click="currentTab = 2">12ヶ月</div>
      </div>
      <div class="tab-content">
        <div class="tab1" v-show="currentTab === 0">
          <img class="tab-img" src="./img/open-close_3month01.png" alt="3ヶ月">
        </div>
        <div class="tab2" v-show="currentTab === 1">
          <img class="tab-img" src="./img/open-close_6month01.png" alt="6ヶ月">
        </div>
        <div class="tab3" v-show="currentTab === 2">
          <img class="tab-img" src="./img/open-close_12month01.png" alt="12ヶ月">
        </div>
        <p class="menu_text">※価格はすべて税込表示となっております。</p>
      </div>

      <!-- <h2 class="tab-title">ETP通い放題</h2>
      
        <div class="tab-content">
            <img class="tab-img" src="./img/etp_open-15.png" alt="">
          
          <p class="menu_text">※価格はすべて税込表示となっております。</p>
        </div>
        <div class="tab-content">
            <img class="tab-img" src="./img/etp_open-close.png" alt="">
          
          <p class="menu_text">※価格はすべて税込表示となっております。</p>
        </div> -->
    </div>


</template>

<script>
export default {
  name: 'TabMenuSubscription',
  data () {
    return {
      currentTab: 0,
      id: 0,
      tabName: "",
      tabs: [
        {id: 1, tabName: 'OPEN～15時'},
        {id: 2, tabName: 'OPEN～CLOSE'},
      ],
    }
  }
}  
</script>

<style scoped>
.plan-explanation{
  margin-bottom: 2em;
  line-height: 2em;
}

.plan-explanation-main{
  color: black;
  text-align: center;
  font-weight: 600;
}
.plan-explanation-sub{
  text-align: center;
  color: var(--main-color);
  margin:10px auto;
}

.btn-container {
  display: flex;
  justify-content: center;
}

.button-color-1{
  color: var(--main-color);
  font-weight: 600;
  background-color: #c7e2e7;
}

.button-color-2{
  color: var(--main-color);
  font-weight: 600;
  background-color: #9bcccf;
}
.button-color-3{
  color: white;
  font-weight:600;
  background-color: var(--main-color);
}

.tab-img{
  width: 100%;
}
  /* PC表示 */
  @media screen and (min-width:821px){
    .plan-explanation-main{
      font-size: 2rem;
    }
    .plan-explanation-sub{
      font-size: 1.2rem;
    }

    .plan-small{
      font-size:0.8rem;
    }

    .tab-title{
      color: black;
      font-size: 2.5rem;
      text-align: center;

      width: 30vw;
      padding: 1em 3em;

      left: 0;
      right: 0;
      margin: 1.5em auto;
    }
    .tab-content{
      max-width: 72vw;
      margin: 0 auto; 
      margin-bottom:100px;
    }

    .button-box {
      font-size: 1.6rem;
      letter-spacing: 0.1em;
      
      text-align: center;

      -webkit-appearance: none;
      -moz-appearance: none;
            appearance: none;
      border: 0;
      border-radius: 1em 1em 0 0;
      width: 24vw;
      padding: 1em 0;
      white-space: nowrap;
    }
    .tab1{
      background-color: #c7e2e7;
      padding: 1.5em 3em;
    }

    .tab2{
      background-color: #9bcccf;
      padding: 1.5em 3em;
    } 

    .tab3{
      background-color: var(--main-color);
      padding: 1.5em 3em;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .plan-explanation-main{
      font-size: 5vw;
    }
    .plan-explanation-sub{
      font-size: 3vw;
      margin:0;
      line-height:1.6em;
    }

    .plan-small{
      font-size: 2vw;
    }

    .tab-title{
      color: black;
      /*font-size: 7vw;*/
      text-align: center;
      font-size: 25px;
      text-align: center;
      border-bottom: solid 1px #068EAB;
      width: 50vw;
      padding: 10px 0;

      left: 0;
      right: 0;
      margin: 1.5em auto;

      white-space: nowrap;
    }

    .tab-content{
      max-width: 90vw;
      margin: 0 auto; 
      margin-bottom:60px;
    }

    .button-box {
      font-size: 3vw;
      letter-spacing: 0.1em;
      
      text-align: center;

      -webkit-appearance: none;
      -moz-appearance: none;
            appearance: none;
      border: 0;
      border-radius: 1em 1em 0 0;
      width: 30vw;
      padding: 1em 0;
      white-space: nowrap;
    }

    .tab1{
      background-color: #c7e2e7;
      padding: 1.5em 1.5em;
    }

    .tab2{
      background-color: #9bcccf;
      padding: 1.5em 1.5em;
    } 

    .tab3{
      background-color: var(--main-color);
      padding: 1.5em 1.5em;
    } 
  }
</style>